import axiosInstance from '../../../helpers/api';

export const createStudentExams = data => {
    return axiosInstance.post(`/students/student_type_exams`, data);
};

export const getStudentExams = () => {
    return axiosInstance.get(`/students/student_exams/tag_exams`);
};

export const getStudentTags = () => {
    return axiosInstance.get(`/students/tags`);
};

export const createTagExam = (data) => {
    return axiosInstance.post(`/students/student_exams/tags`, data);
};

export const getStudentExamQuestions = (id) => {
    return axiosInstance.get(`/students/student_exams/get_questions/${id}`);
};
